import {
  Box,
  Button,
  Container
} from "@mui/material";
import { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Link } from "react-router-dom";
import CustomDialog from "../components/CustomDialog";
import CustomTabPanel from "../components/TabPanel/CustomTabPanel";
import StyledTab from "../components/TabPanel/StyledTab";
import StyledTabs from "../components/TabPanel/StyledTabs";
import Attribute from "./Attribute";
import EditAttribute from "./EditAttribute";

/**
 * Overview of different attribute-filters.
 * @param {*} param0 
 * @returns 
 */
export default function AttributeOverview({ userInfo }) {
  const [value, setValue] = useState(0);

  const [isOpenCreate, setIsOpenCreate] = useState(null);
  const [triggerValue, setTriggerValue] = useState(1);

  const intl = useIntl();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const changeTab = (index) => {
    setValue(index);
  }

  /**
   * Open the creation-dialog.
   */
  const handleOpenCreate = () => {
    setIsOpenCreate({ key: '', type: 'TEXT', publicFlag: false, unit: null });
  }

  /**
   * Close the creation-dialog and display private attributes, if attribute was created.
   * @param {*} attribute 
   */
  const handleCloseCreate = (attribute) => {
    if (attribute) {
      // creating attribute was successful
      // display private attributes
      setValue(0);
      // trigger reload
      setTriggerValue(prev => prev + 1);
    }
    setIsOpenCreate(null);
  };

  return (
    <Container>
      <Button
        variant="contained"
        color="success"
        component={Link}
        onClick={handleOpenCreate}
        sx={{ float: "right" }}
      >
        <FormattedMessage id="Overview.create" />
      </Button>
      <h3><FormattedMessage id="Attribute" /></h3>
      <Box xs={{ width: '100%' }}>
        <StyledTabs
          value={value}
          onChange={handleChange}
          aria-label="style data tabs"
        >
          <StyledTab label={intl.formatMessage({ id: "Attributes.private" })} />
          <StyledTab label={intl.formatMessage({ id: "Attributes.public" })} />
          {userInfo?.isAdmin && <StyledTab label={intl.formatMessage({ id: "Attributes.additional" })} />}
        </StyledTabs>
      </Box>
      <CustomTabPanel value={value} index={0} >
        <Attribute userInfo={userInfo} publicFlag={false} allFlag={false} changeTab={changeTab} trigger={triggerValue} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1} >
        <Attribute userInfo={userInfo} publicFlag={true} allFlag={false} changeTab={changeTab} trigger={triggerValue} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2} >
        <Attribute userInfo={userInfo} publicFlag={false} allFlag={true} changeTab={changeTab} trigger={triggerValue} />
      </CustomTabPanel>
      <CustomDialog
        isOpen={isOpenCreate ? true : false}
        handleClose={() => setIsOpenCreate(null)}
        title={intl.formatMessage({ id: "Attributes.createNew" })}
        content={<EditAttribute userInfo={userInfo} id={null} attribute={isOpenCreate} onClose={handleCloseCreate} />}
        maxWidth="xl"
        hideConfirmation={true}
        displayClose={true}
      />
    </Container>
  );
}